import { useMutation, useQueryClient } from '@tanstack/vue-query'
import { broadcastQueryData } from 'src/composables/app/system/useBroadcastChannel'
import { userService } from 'src/services/api/user.service'
import { log } from 'src/services/app/log.service'
import { notifyMsgs, notifyService } from 'src/services/app/notify.service'
import { MUTATION_KEYS, QUERY_KEYS } from 'src/services/consts/queries.const'
import { wrapMutationAsync } from 'src/services/app/util.service'

/**
 * Removes a verified additional email, or a pending/expired verification.
 * Pending verifications call `remove_email_verification`; verified addresses
 * call `remove_additional_email`. The confirm dialog lives in the UI layer.
 */
export function useRemoveAdditionalEmailMutation() {
  const queryClient = useQueryClient()

  const mutation = useMutation({
    mutationKey: [MUTATION_KEYS.REMOVE_ADDITIONAL_EMAIL],
    mutationFn: ({ email, isPendingVerification = false }) =>
      userService.removeAdditionalEmail({ email, isPendingVerification }),

    onSuccess: (envelope) => {
      if (envelope.userInfo != null) {
        queryClient.setQueryData([QUERY_KEYS.USER_INFO], envelope.userInfo)
        broadcastQueryData([QUERY_KEYS.USER_INFO], envelope.userInfo)
      }
      notifyService.success(notifyMsgs.success.additionalEmailRemoved)
    },

    onError: (error) => {
      log.error('[RemoveAdditionalEmail] Failed to remove email', error)
      notifyService.error(notifyMsgs.error.removeAdditionalEmail)
    },
  })

  return {
    removeAdditionalEmail: wrapMutationAsync(mutation.mutateAsync),
    isRemovingAdditionalEmail: mutation.isPending,
  }
}
